const alerts = {
  configuringData: 'Attendi, stiamo configurando i tuoi dati',
  configuringError:
    'Si è verificato un errore durante la configurazione, cortesemente avvia nuovamente il procedimento',
  configuringFailed:
    'Siamo spiacenti, si è verificato un errore nella configurazione dei tuoi dati. Cortesemente riprova più tardi, se il problema persiste contatta l\'amministratore',
  configuringSuccess: 'Configurazione riuscita',
  errorOccurred: 'Siamo spiacenti, si è verificato un errore',
  noCode: 'Nessun codice',
  noMessage: 'Nessun messaggio',
  notAvailable: 'Non disponibile',
  pageNotFound: '404 - Pagina non trovata',
  pleaseWait: 'Attendere prego',
  savedData: 'Dati salvati',
  triggeredAnError:
    'È successo qualcosa nell\'impostazione della richiesta che ha provocato un errore',
  unansweredRequest:
    'La richiesta è stata inviata ma non è stata ricevuta alcuna risposta',
};

export default alerts;
